import { DefaultTheme } from "styled-components";
import { TechSector } from "../../config/tech-sector";

export const getTechSectorBackground = (theme: DefaultTheme, sectorType: TechSector | undefined, inactive = false) => {
    if (inactive || !sectorType) return theme.colors.gray1;

    const colors = theme.colors.sectors[sectorType];

    if (sectorType === TechSector.HEATING) {
        return `linear-gradient(to right, ${colors[0]} 0%,${colors[1]} 100%)`
    } else {
        return `linear-gradient(to top, ${colors[0]} 0%,${colors[1]} 100%)`
    }
}